// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__33ff4","footer":"ChangeClinic_footer__1CFdm"};